// @ts-strict-ignore
import type { WorkflowNodeProps, WorkflowNodeType } from 'flow/service/graph';
import ImportedTailNode from './ImportedTailNode';
import InputAttributeNode from './InputAttributeNode';
import MatrixModelNode from './MatrixModelNode';
import OutcomeNode from './OutcomeNode';
import OutputAttributeNode from './OutputAttributeNode';
import RiskCalculationNode from './RiskCalculationNode';
import ServiceNode from './ServiceNode';
import SkeletonNode from './SkeletonNode';
import TagNode from './TagNode';
import PreviewNode from './PreviewNode';
import WorkflowRoutingNode from './WorkflowRoutingNode';
import ExitNode from './ExitNode';
import OutcomeReasonNode from './OutcomeReasonNode';
import FolderNode from './FolderNode';
import SnippetNode from './SnippetNode';

const nodeTypes: Record<WorkflowNodeType, React.ComponentType<WorkflowNodeProps>> = {
  exit: ExitNode,
  folder: FolderNode,
  importedTailNode: ImportedTailNode,
  inputAttribute: InputAttributeNode,
  matrixModel: MatrixModelNode,
  outcome: OutcomeNode,
  // outcomeReason are explicitly imported outcome reasons, and not a Tag _with_ outcomes
  outcomeReason: OutcomeReasonNode,
  outputAttribute: OutputAttributeNode,
  preview: PreviewNode,
  // riskCalculation is a special type of output attribute with distinct styling
  riskCalculation: RiskCalculationNode,
  service: ServiceNode,
  snippet: SnippetNode,
  skeleton: SkeletonNode,
  tag: TagNode,
  workflow: WorkflowRoutingNode,
};


export default nodeTypes;
